<template>
  <div class="patient-info-card" v-if="patientPortrait">
    <div class="patient-info-card__header">
      <div class="patient-info-card__title">患者画像</div>
      <i class="el-icon-close patient-info-card__close" @click="$emit('close')"></i>
    </div>

    <div class="patient-info-card__tags"
      v-if="patientPortrait.patientLabels && patientPortrait.patientLabels.length > 0">
      <span v-for="tag in patientPortrait.patientLabels" :key="tag" class="patient-info-card__tag">{{ tag }}</span>
    </div>

    <section class="patient-info-card__main-panel">
      <div class="patient-info-card__panel-content">
        <div class="patient-info-card__label">
          <span class="patient-info-card__dot patient-info-card__label--orange"></span>
          <span>近半年总消费</span>
        </div>
        <div class="patient-info-card__amount">￥{{ formatMoney(patientPortrait.halfYearTotalConsume) }}</div>
        <div class="patient-info-card__period">统计周期：{{ computedTimeRange }} </div>
      </div>
      <img class="patient-info-card__chart" :src="imgArr.a19" alt="chart">
    </section>

    <div class="patient-info-card__stats">
      <section class="patient-info-card__stat">
        <div class="patient-info-card__label">
          <span class="patient-info-card__dot patient-info-card__label--blue"></span>
          <span>近半年就诊</span>
        </div>
        <div class="patient-info-card__value">{{ patientPortrait.halfYearVisitCount }}<span>次</span></div>
      </section>
      <section class="patient-info-card__stat ">
        <div class="patient-info-card__label">
          <span class="patient-info-card__dot patient-info-card__label--green"></span>
          <span>近3月月均消费</span>
        </div>
        <div class="patient-info-card__value">￥{{ formatMoney(patientPortrait.threeMonthTotalConsume) }}</div>
      </section>
      <section class="patient-info-card__stat ">
        <div class="patient-info-card__label">
          <span class="patient-info-card__dot patient-info-card__label--purple"></span>
          <span>钱包余额</span>
        </div>
        <div class="patient-info-card__value">￥{{ formatMoney(patientPortrait.walletBalance) }}</div>
      </section>
    </div>
  </div>
</template>

<script>
import { imgArr } from '@/assets/images/img'
export default {
  name: 'PatientInfo',
  props: {
    patientPortrait: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      imgArr
    }
  },
  computed: {
    computedTimeRange() {
      // 从今天开始往前推半年
      const today = new Date()
      const halfYearAgo = new Date(today.getTime() - 6 * 30 * 24 * 60 * 60 * 1000)
      return `${halfYearAgo.getFullYear()}-${halfYearAgo.getMonth() + 1}-${halfYearAgo.getDate()} ～ ${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
    }
  },
  methods: {
    formatMoney(value) {
      const numberValue = Number(value || 0)
      return numberValue.toLocaleString('zh-CN')
    },
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.patient-info-card {
  width: 454px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #ffffff;
  font-family: PingFang SC, Microsoft YaHei, Arial, sans-serif;
}

.patient-info-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f5;
  padding-bottom: 12px;
}

.patient-info-card__title {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}

.patient-info-card__close {
  font-size: 18px;
  color: #69728a;
  cursor: pointer;
}

.patient-info-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
}

.patient-info-card__tag {
  height: 26px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: rgba(255, 162, 74, 0.15);
  font-weight: 400;
  font-size: 13px;
  color: #FE8F1F;
}

.patient-info-card__main-panel {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-radius: 8px;
  background: #F7F8F9;
}

.patient-info-card__label {
  display: flex;
  align-items: center;
  color: #667182;
  font-size: 13px;
  line-height: 22px;
}

.patient-info-card__dot {
  width: 6px;
  height: 6px;
  margin-right: 9px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 8px currentColor;
}

.patient-info-card__label--orange {
  color: #F3943A;
}

.patient-info-card__label--blue {
  color: #1890FF;
}

.patient-info-card__label--green {
  color: #28A881;
}

.patient-info-card__label--purple {
  color: #8E41E3;
}

.patient-info-card__amount {
  margin-top: 6px;
  font-weight: bold;
  font-size: 24px;
  color: #F3943A;
}

.patient-info-card__period {
  margin-top: 6px;
  font-weight: 400;
  font-size: 12px;
  color: #667182;
}

.patient-info-card__chart {
  width: 76px;
  height: 64px;
}

.patient-info-card__stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 12px;
}

.patient-info-card__stat {
  min-height: 76px;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #F7F8F9;
}

.patient-info-card__stat--blue {
  background: #EFFAFF;
}

.patient-info-card__stat--green {
  background: #F4F9F7;
}

.patient-info-card__stat--purple {
  background: #F6F5FC;
}

.patient-info-card__value {
  margin-top: 6px;
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}

.patient-info-card__value span {
  margin-left: 4px;
  font-weight: 400;
  font-size: 13px;
  color: #000000;
}
</style>